import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {IPagedResponse} from '../../../models/paged-bulkfetch/IPagedResponse';
import {
  StudentTicketListViewAsmResponseDTO
} from '../../../models/student-ticket/list-view/StudentTicketListViewAsmResponseDTO';
import {IPageRequest} from '../../../models/paged-bulkfetch/IPageRequest';
import {
  StudentTicketListViewRequestDTO
} from '../../../models/student-ticket/list-view/StudentTicketListViewRequestDTO';
import {TerminationRequestDTO} from "../../../models/student-ticket/termination/TerminationRequestDTO";
import {HttpHeaderService} from "../../utils/http/http-header.service";
import {TerminationConstraintsDTO} from "../../../models/student-ticket/termination/TerminationConstraintsDTO";
import {AddressDataInfoDto} from "../../../models/student-ticket/list-view/AddressDataInfoDto";
import {SchoolDataInfoDto} from "../../../models/student-ticket/list-view/SchoolDataInfoDto";
import {NameDataInfoDto} from "../../../models/student-ticket/list-view/NameDataInfoDto";

@Injectable({
  providedIn: 'root'
})
export class StudentTicketService {

  configUrl = 'api/student-ticket';

  constructor(
    private readonly http: HttpClient,
    private readonly headerService: HttpHeaderService,
  ) {}

  getTicketList(request: IPageRequest<StudentTicketListViewRequestDTO>): Observable<IPagedResponse<StudentTicketListViewAsmResponseDTO>> {
    return this.http.post<IPagedResponse<StudentTicketListViewAsmResponseDTO>>(`${this.configUrl}/bulk`, request, {headers: this.headerService.getAuthHeader()});
  }

  planTermination(uuid: string, request: TerminationRequestDTO): Observable<any> {
    return this.http.post<any>(`${this.configUrl}/${uuid}/plan-termination`, request, {headers: this.headerService.getAuthHeader()});
  }

  cancelTermination(ticketId: string, terminationId: string): Observable<any> {
    return this.http.post<any>(`${this.configUrl}/${ticketId}/cancel-termination/${terminationId}`, null, {headers: this.headerService.getAuthHeader()});
  }

  getTerminationConstraints(uuid: string): Observable<TerminationConstraintsDTO> {
    return this.http.get<TerminationConstraintsDTO>(`${this.configUrl}/termination-constraints/${uuid}`, {headers: this.headerService.getAuthHeader()});
  }

  adjustAddressData(uuid: string, addressDataChangeDto: AddressDataInfoDto): Observable<any> {
    return this.http.post<any>(`${this.configUrl}/${uuid}/update-address-data`,  addressDataChangeDto, {headers: this.headerService.getAuthHeader()});
  }

  adjustSchoolData(uuid: string,  schoolDataChangeDto: SchoolDataInfoDto): Observable<any> {
    return this.http.post<any>(`${this.configUrl}/${uuid}/update-school-data`,  schoolDataChangeDto, {headers: this.headerService.getAuthHeader()});
  }

  adjustNameData(uuid: string,  nameDataChangeDto: NameDataInfoDto): Observable<any> {
    return this.http.post<any>(`${this.configUrl}/${uuid}/update-name-data`,  nameDataChangeDto, {headers: this.headerService.getAuthHeader()});
  }

}
